'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { JSX } from 'react';
import { createPortal } from 'react-dom';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Icon } from '@/components/ui/icon';
import { PlusSignIcon } from '@/components/ui/icon/glyphs';
import { useHydrated } from '@/hooks/ui/use-hydrated';
interface LaunchpadHeaderProps {
  /** Route-owned discovery controls and info action. */
  actions?: JSX.Element;
  creationOpen: boolean;
  /** Opens the create-proposal flow (dialog is mounted by the parent layout). */
  onLaunchMarketClick: () => void;
}
export function LaunchpadHeader(t0) {
  const $ = _c(29);
  const {
    actions,
    creationOpen,
    onLaunchMarketClick
  } = t0;
  const t = useTranslations("launchpad.feed");
  const mounted = useHydrated();
  let t1;
  if ($[0] !== t) {
    t1 = t("launchCta");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== creationOpen || $[3] !== onLaunchMarketClick || $[4] !== t1) {
    t2 = <div className="fixed right-4 z-sticky bottom-[calc(5.5rem+env(safe-area-inset-bottom))] sm:hidden [body:has([data-proposal-creation-loading])_&]:hidden"><AnimatedButton prefix={PlusSignIcon} className="h-14 w-14 rounded-full shadow-elevation-sticky" onClick={onLaunchMarketClick} aria-label={t1} aria-haspopup="dialog" aria-expanded={creationOpen} /></div>;
    $[2] = creationOpen;
    $[3] = onLaunchMarketClick;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const mobileFab = t2;
  let t3;
  if ($[6] !== t) {
    t3 = t("title");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <h1 className="min-w-0 text-heading font-bold">{t3}</h1>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = actions !== undefined && actions;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Icon icon={PlusSignIcon} className="mr-1 size-4" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("launchCta");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== creationOpen || $[14] !== onLaunchMarketClick || $[15] !== t7) {
    t8 = <AnimatedButton variant="primary" onClick={onLaunchMarketClick} aria-haspopup="dialog" aria-expanded={creationOpen} className="hidden sm:inline-flex lg:hidden">{t6}{t7}</AnimatedButton>;
    $[13] = creationOpen;
    $[14] = onLaunchMarketClick;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t5 || $[18] !== t8) {
    t9 = <div className="flex items-center gap-2">{t5}{t8}</div>;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t4 || $[21] !== t9) {
    t10 = <div className="flex items-center justify-between gap-2">{t4}{t9}</div>;
    $[20] = t4;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== mobileFab || $[24] !== mounted) {
    t11 = mounted && createPortal(mobileFab, document.body);
    $[23] = mobileFab;
    $[24] = mounted;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}